module.exports = __webpack_public_path__ + "img/basic.103a033b.png";